module.exports = __webpack_public_path__ + "static/media/ww_teli1.be8db7b6.gif";